import firebase from "firebase";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB_t5bMK048nEDQsyEv7nVYZuET8KelkjI",
  authDomain: "molla-ecommerce.firebaseapp.com",
  projectId: "molla-ecommerce",
  storageBucket: "molla-ecommerce.appspot.com",
  messagingSenderId: "552118211758",
  appId: "1:552118211758:web:24a907ebde01f13dc6c93f",
  measurementId: "G-9K8F8WVEK0",
};
export const firebaseApp = firebase.initializeApp(firebaseConfig);
const auth = firebase.auth();
const db = firebaseApp.firestore();
const provider = new firebase.auth.GoogleAuthProvider();
export const signInWithGoogle = () => auth.signInWithPopup(provider);
export { auth, db };
